



























































































































import { Component, mixins } from '@niknevis/vue-modules'
import BaseSelect from '@/modules/shared/components/shared/kit/BaseSelect.vue'
import BaseCard from '@/modules/shared/components/shared/base/BaseCard.vue'
import BaseTooltip from '@/modules/shared/components/shared/kit/BaseTooltip.vue'
import BaseInput from '@/modules/shared/components/shared/kit/BaseInput.vue'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import { Prop, PropSync } from 'vue-property-decorator'
import Toggle from '@/modules/shared/components/shared/kit/Toggle.vue'
import Modal from '@/modules/common/dialog/components/shared/Modal.vue'
import { SerializerMixin } from '@/modules/shared/mixins/serializerMixin'
import { UserInfoSerializer } from '@/modules/user/serializer/user-info.serializer'
import Radio from '@/modules/shared/components/shared/kit/Radio.vue'

@Component({
  components: {
    Radio,
    BaseSelect,
    BaseCard,
    BaseTooltip,
    BaseInput,
    BaseButton,
    Toggle,
    Modal
  }
})
export default class WriterBankAccountEditModal extends mixins<SerializerMixin<UserInfoSerializer>>(SerializerMixin) {

  @Prop() info!: any
  @PropSync('displayModal') modal !: boolean

  model = new UserInfoSerializer

  loading = false

  queryModel() {
    return {
      bank_account: this.info.data.bank_account[0]
    }
  }

  get withdrawPeriods() {
    return this.info.withdraw_periods
  }

  get withdrawOptions() {
    let objectArray = Object.entries(this.withdrawPeriods)
    let array = []
    objectArray.forEach(([value, key]) => {
      array.push({
        label: key,
        value: value
      })
    })
    return array
  }

  get bankOptions() {
    let objectArray = Object.entries(this.info.bank_names)
    let array = []
    objectArray.forEach(([value, key]) => {
      array.push({
        label: key,
        value: value
      })
    })
    return array
  }

  async updateBankAccount() {
    this.loading = true
    let ok = false

    try {
      ok = await this.model.$validate()
      if (ok) {
        //
      }
    } catch (e) {
      this.loading = false
    }
  }

}
